import { render, staticRenderFns } from "./modalHorasSobreavisoBase.vue?vue&type=template&id=e50a910a&scoped=true&"
import script from "./modalHorasSobreavisoBase.vue?vue&type=script&lang=js&"
export * from "./modalHorasSobreavisoBase.vue?vue&type=script&lang=js&"
import style0 from "./modalHorasSobreavisoBase.vue?vue&type=style&index=0&id=e50a910a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50a910a",
  null
  
)

export default component.exports